import { createContext } from 'react'

import { ChooseFrequencyLaterContextProviderValues } from '../types'

export const ChooseFrequencyLaterContext = createContext<ChooseFrequencyLaterContextProviderValues>(
  {} as ChooseFrequencyLaterContextProviderValues
)
